// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal.modal--successmodal{max-width:490px}.success-modal{display:flex;flex-direction:column;align-items:center}.success-modal__title{margin-top:16px;color:#fff;font-size:32px;text-align:center}.success-modal__text{text-align:center;font-size:20px;line-height:120%;color:#90a4ae;margin-top:16px}.success-modal__buttons{margin-top:20px;display:flex;flex-direction:column;width:100%}.success-modal__buttons .button{margin-top:12px;width:100% !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
